import React from 'react'
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import ModalBody from 'react-bootstrap/ModalBody';
import { Container, Row, Col, ModalFooter } from 'react-bootstrap';
import Button from '../../../components/Button';
import Card from 'react-bootstrap/Card';

export type customExternalSiteWarningProps = {
  showExternalSiteWarning: boolean;
  handleCloseExternalSiteWarning: () => void;
};

const ExternalSiteWarning = ({
    showExternalSiteWarning,
    handleCloseExternalSiteWarning,
  }: customExternalSiteWarningProps) => {
  return (
<Modal
      show={showExternalSiteWarning}
      onHide={handleCloseExternalSiteWarning}
      dialogClassName="modal-xl"
      className="custom-benefit-modal"
    >
      <ModalHeader closeButton withBorder>
        <h4 className="text-truncate">External Site Warning</h4>
      </ModalHeader>
      <ModalBody>
        <Container className={'p-0 col-12 pb-10'}>
          <Row>
            <Col>
              <p className="pb-5">The services and information you are about to access are provided by a third-party service provider ("Third Party Services").</p>

              <p className="pb-5">You are responsible for your use of the Third Party Services and any decisions that you make based upon your evaluation and use of the information provided. Your use of the Third Party Services may be subject to terms of use as described on the Third Party Service provider’s website. If you choose to access the Third Party Services, some of your personal information may be made available to the Third Party Service provider to enable it to provide you with the information or services that you request.</p>

              <p className="pb-5">By clicking "I Agree" you acknowledge that you have read and understand these terms and wish to continue.</p>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="secondary-outline"
          onMouseDown={handleCloseExternalSiteWarning}
          className="mt-7 mt-lg-0 order-1"
        >
          I Decline
        </Button>
        <Button
          variant="primary-outline"
          onMouseDown={handleCloseExternalSiteWarning}
          className="mt-7 mt-lg-0 order-1"
        >
          I Agree
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ExternalSiteWarning